import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import MonoButton from "../components/MonoButton";
import PaperBG from "../patterns/PaperBG";

export default function Register() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    first_name: "",
    last_name: ""
  });
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    try {
      const response = await fetch(
        "https://www.denisbitter.de/stage01/api/register_api.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        }
      );

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (jsonErr) {
        console.error("❌ JSON‐Fehler:", jsonErr, "Antwort war:", text);
        setError("Unerwartete Serverantwort.");
        return;
      }

      if (response.ok && data.success) {
        setSuccessMsg(data.message || "Registrierung erfolgreich.");
        // Nach kurzer Verzögerung automatisch zurück zur Login-Seite
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else {
        setError(data.message || "Registrierung fehlgeschlagen.");
      }
    } catch (err) {
      console.error("❌ Netzwerkfehler:", err);
      setError("Server nicht erreichbar.");
    }
  };

  return (
    <PaperBG>
      <div className="flex items-center justify-center min-h-screen px-4">
        <form
          onSubmit={handleSubmit}
          className="max-w-md w-full py-11 px-6 text-xs text-center bg-gray-50 rounded-xl shadow border"
        >
          <h3 className="text-sm font-mono mb-4">Neuen Account erstellen</h3>

          <input
            type="email"
            name="email"
            placeholder="E-Mail"
            value={formData.email}
            onChange={handleChange}
            required
            className="font-mono w-full mb-3 px-4 py-2 border rounded focus:outline-none focus:ring-1 focus:ring-gray-900 text-center"
          />

          <input
            type="password"
            name="password"
            placeholder="Passwort (mind. 6 Zeichen)"
            value={formData.password}
            onChange={handleChange}
            required
            className="font-mono w-full mb-3 px-4 py-2 border rounded focus:outline-none focus:ring-1 focus:ring-gray-900 text-center"
          />

          <input
            type="text"
            name="first_name"
            placeholder="Vorname"
            value={formData.first_name}
            onChange={handleChange}
            required
            className="font-mono w-full mb-3 px-4 py-2 border rounded focus:outline-none focus:ring-1 focus:ring-gray-900 text-center"
          />

          <input
            type="text"
            name="last_name"
            placeholder="Nachname"
            value={formData.last_name}
            onChange={handleChange}
            required
            className="font-mono w-full mb-3 px-4 py-2 border rounded focus:outline-none focus:ring-1 focus:ring-gray-900 text-center"
          />

          <MonoButton type="submit" className="w-full py-2 rounded mb-2">
            Registrieren
          </MonoButton>

          <p className="mt-3 text-xs text-gray-600">
            Schon registriert?{" "}
            <Link to="/login" className="underline text-gray-900">
              Einloggen
            </Link>
          </p>

          {successMsg && (
            <p className="text-green-500 text-sm mt-2">{successMsg}</p>
          )}
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        </form>
      </div>
    </PaperBG>
  );
}
